export const getSearchPlaceholder = (placeholderSentences?: string[]): string =>
  placeholderSentences?.[0] ?? '';
